export default __webpack_public_path__ + "media/color/rcn-cfef152b.svg";